export default {
    methods: {
        toUpperCase(dados, campo) {
            if (dados && dados[campo]) {
                dados[campo] = dados[campo].toUpperCase();
            }
        }
    },
};